import {SLQueryParamConfig} from '#/contexts/query-params-provider';
import {UIStatusContext} from '#/contexts/ui-status-provider';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import {getExchangeRouteWithQueryParams} from '#/routes/exchange/get-exchange-route-with-query-params';
import {ClassName, DefaultChildren} from '#/utils/utils';
import {MapIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {useQueryParams} from 'use-query-params';

export const OpenMapFloatingButton: FunctionComponent<DefaultChildren> = () => {
  const {isActionMenuOpen} = useContext(UIStatusContext);

  return (
    <div
      className={
        'fixed flex-center left-[38%] xs:left-[38%] md:left-[48%] bottom-3 md:bottom-6 data-[actionmenuopened=true]:hidden lg:data-[actionmenuopened=true]:flex z-20 pointer-events-none'
      }
      data-actionmenuopened={isActionMenuOpen}
    >
      <OpenMapButton />
    </div>
  );
};

export const OpenMapButton: FunctionComponent<ClassName> = ({className = ''}) => {
  const {t} = useTranslation('translation');

  const [queryParams] = useQueryParams<SLQueryParamConfig>();

  return (
    <Link
      to={getExchangeRouteWithQueryParams(ExchangeRoute.MAP, queryParams)}
      className={`w-fit flex items-center gap-2 px-5 py-3 rounded-full bg-deepblue shadow-2xl hover:scale-105 transition-all ease-in-out cursor-pointer whitespace-nowrap pointer-events-auto ${className}`}
    >
      <MapIcon className='w-4 h-4 fill-white stroke-transparent' />
      <span className='text-sm text-white font-semibold'>{t('actions.showMap')}</span>
    </Link>
  );
};
